import { Component } from '@angular/core';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})
export class BrandsComponent {
  swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    autoplay: {
      delay: 10000, // Changed to 10 seconds (10000 ms)
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
    speed: 1000,
    effect: 'slide',
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 30
      }
    }
  };

  brands = [
    { name: 'GUERLAIN', url: 'https://www.laparfumerie.eu/guerlain', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_400x400px.png' },
    { name: 'DIOR', url: 'https://www.laparfumerie.eu/dior', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_DIOR.png' },
    { name: 'YSL', url: 'https://www.laparfumerie.eu/ysl', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_YSL.png' },
    { name: 'LANCÔME', url: 'https://www.laparfumerie.eu/lancome', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LANCOME.jpg' },
    { name: 'kérastase', url: 'https://www.laparfumerie.eu/kerastase', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/logo-kerastase.jpg' },
    { name: 'clarins', url: 'https://www.laparfumerie.eu/clarins', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_CLARINS.jpg' },
    { name: 'JEAN-PAUL GAULTIER', url: 'https://www.laparfumerie.eu/jean_paul_gaultier', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/JEAN_PAUL_GAULTIER.jpg' },
    { name: 'hermès', url: 'https://www.laparfumerie.eu/hermes', image: 'https://www.laparfumerie.eu/media/amasty/shopby/option_images/slider/LOGO_HERMES.png' }
  ];

  trackById(index: number, brand: any): string {
    return brand.name;
  }
}
